module.exports = __webpack_public_path__ + "static/WilderWorld-73137b479ddc744a8e40be91bb245d43.png";